module.exports = __webpack_public_path__ + "static/media/hit-count.80e1ed8f.png";